// extracted by mini-css-extract-plugin
export default {"title":"O2lATz_jMTSWoXY7n5yq","carousel":"MHagDRmCVN6Ul3qEMTvf","extraimageContainerClass":"GgIatuDERkkon08N7LBQ"};